(function () {

function $6b63b867b61f56af$export$5fbb06d18f22a9f(root = document) {
    if (document.body.classList.contains('block-editor-page')) return;
    root.querySelectorAll('.featured-projects').forEach((block)=>{
        if (block.dataset.lineReady || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        block.dataset.lineReady = 'true';
        block.classList.add('has-line-reveal');
        const observer = new IntersectionObserver((entries)=>{
            if (!entries.some((entry)=>entry.isIntersecting)) return;
            block.classList.add('is-line-visible');
            observer.disconnect();
        }, {
            threshold: 0,
            rootMargin: '0px 0px -10% 0px'
        });
        observer.observe(block);
    });
}


const $a4aa29925848735f$var$runBlock = ()=>(0, $6b63b867b61f56af$export$5fbb06d18f22a9f)(document);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $a4aa29925848735f$var$runBlock, {
    once: true
});
else $a4aa29925848735f$var$runBlock();

})();
//# sourceMappingURL=featured-projects.js.map
